import React, { useEffect } from "react"
import { makeStyles, withStyles } from "@material-ui/core/styles"
import { Dialog, DialogContent } from "@material-ui/core"
// import { FormattedMessage } from "react-intl"
import useTimeout from "hooks/useTimeout"
import { backgroundFixed } from "utils/backgroundFixed.js"

const useStyles = makeStyles(theme => ({
  content: {
    [theme.breakpoints.down("xs")]: {
      maxHeight: "calc(100vh - 200px)",
    },
    whiteSpace: "pre-line",
    wordBreak: "normal",
    padding: "30px 23px",
  },

  listBox: {
    borderRadius: "8px",
    listStyle: "none",
    padding: "18px 15px",
    margin: "0 -8px",
  },

  listText: {
    color: "#333",
    fontWeight: "bold",
    lineHeight: "18px",
    marginBottom: "10px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "14px",
    },
    "&:last-child": {
      marginBottom: "0",
    },
  },

  closeButton: {
    textTransform: "none",
  },
}))

const StyledDialog = withStyles({
  paperFullWidth: {
    maxWidth: "560px",
    width: "calc(100vw - 30px)",
  },
  paper: {
    marginLeft: "15px",
    marginRight: "15px",
    marginTop: "34px",
    borderRadius: "8px",
  },
})(Dialog)

const TimeoutModal = () => {
  const classes = useStyles()
  const { timeoutModalIsOpen, storeTimeoutModalIsOpen } = useTimeout()

  const handleClose = () => {
    storeTimeoutModalIsOpen(false)
  }

  useEffect(() => {
    // unmount時
    return () => {
      backgroundFixed(false)
    }
  }, [])

  return (
    <>
      <StyledDialog
        fullWidth
        open={timeoutModalIsOpen}
        onClose={handleClose}
        TransitionProps={{
          onEnter: () => backgroundFixed(true),
          onExited: () => backgroundFixed(false),
        }}
        aria-labelledby="timeoutModal"
        data-testid="timeoutModal"
      >
        <DialogContent className={classes.content}>
          <ul className={classes.listBox}>
            <li className={classes.listText}>処理に時間がかかっています</li>
            <li className={classes.listText}>
              お手数ですが、画面を更新してください
            </li>
          </ul>
        </DialogContent>
      </StyledDialog>
    </>
  )
}

export default TimeoutModal
